import React from 'react';
import './containers/index.css';
import Navigation from './components/Navigation/Navigation';
import Logo from './components/Logo/Logo';
import Particles from 'react-particles-js';
import CharacterList from './components/Characters-List/charactersList';
import SpellList from './components/Spell-List/SpellList';
import Signin from './components/signin/Signin';
import Register from './components/register/Register';
import Searchbox from './components/Searchboxes/Searchbox';
import SearchButton from './components/SearchButton/SearchButton';
import Profile from './components/Profile/Profile';
import Heading from './components/Heading/Heading';
import {character} from './containers/character';
import {spell} from './containers/spell';

//Shows Particles in background
const Particle= {
  particles: {
    number:{
      value:120,
      density: {
        enable:true,
        value_area:1550
      }
    },
    move:{
      enable:true,
      speed:12,
    }
  }
}

const initialState={
  route: 'register',
  isSignedIn:false,
  backgroundJPG: 'signin',
  character: character,
  spell: spell,
  searchByCharacters: true,
  searchCharacterName:'',
  searchCharacterHouse:'',
  searchSpell:'',
  user:{
    id:'',
    name:'',
    email:'',
    entries:0,
    joined: '',
    house: '',
  }
}

class Home extends React.Component {
  PotterKey = '$2a$10$fbzTUBnZ6qVxppZkhQnwT.i2OrTfn2FIcgpv4eQNRCY/6AjLzldoq'
  constructor(){
    super();
    //Defines state of the app
    this.state= initialState
  }

  loadUser = (users)=>{
    this.setState({user:
      {
        id:users.id,
        name:users.name,
        email:users.email,
        entries:users.entries,
        joined: users.joined,
        house: users.house
      }
    })
    this.setState({backgroundJPG: 'List'})
  }

  searchByCharacter=()=>{
    this.setState({searchByCharacters:true})
  }

  searchByHouse=()=>{
    this.setState({searchByCharacters:false})
  }

  searchChange=(event)=>{
    if(this.state.route==='spell'){
      this.setState({searchSpell: event.target.value})
    } else{
      this.setState({searchCharacterName: event.target.value})
    }
  }

  searchHouse=(event)=>{
    this.setState({searchCharacterHouse: event.target.value})
  }

  //CHANGES THE ROUTE THUS CHANGING THE STRUCTURE OF APP
  onRouteChange = (rote)=>{
    if (rote=== 'signout'){
      this.setState(initialState)
    }
    else if(rote === 'home') {
      this.setState({isSignedIn: true})
    } 
    this.setState({route:rote})
  }

  render(){
    const{isSignedIn,route,character,spell,searchCharacterName,searchSpell,searchByCharacters,searchCharacterHouse} = this.state;
    
    const {onRouteChange,loadUser,searchChange,searchHouse,searchByCharacter,searchByHouse} = this;

    const filterCharacter= character.filter(characters =>{
      if (searchByCharacters) {
        return (
          characters.name.toLowerCase().includes(searchCharacterName.toLowerCase())
        )
      } else {
        return(
          characters.house.toLowerCase().includes(searchCharacterHouse.toLowerCase())
        )
      } 
    });

    const filterSpell= spell.filter(spells =>{
      return spells.spell.toLowerCase().includes(searchSpell.toLowerCase());
    });

    if (route==='register'|| route==='signin') {
      document.querySelector("#root").style.height="120vh"
    } else{
      document.querySelector("#root").style.height=""
    }

    return (
      <div className="App">
        <Navigation  onRouteChange={onRouteChange} isSignedIn={isSignedIn}/>
        <Particles className="particles"
        params={Particle} />
        {route === 'home'
        ?//Ternary operators ? means IF and : means ELSE
        <div className="potter">
          <div className="potter_info">
            <Logo />
            <SearchButton searchByCharacter={searchByCharacter} searchByHouse={searchByHouse}/>
            <Searchbox searchChange={searchChange} 
            searchByCharacters={searchByCharacters}
            searchHouse={searchHouse} 
            route={route}/>
            <CharacterList character={filterCharacter} />
          </div>
        </div>
        : (
          route === 'signin'
          ?<div>
            <Heading />
            <Signin loadUser={loadUser} onRouteChange={onRouteChange}/>
           </div>
          :(
            route === 'profile'
            ?<div className="potter">
              <Profile 
              name={this.state.user.name} 
              house = {this.state.user.house} 
              onRouteChange={onRouteChange} 
              email={this.state.user.email} 
              joined={this.state.user.joined}/>
            </div>
            :(route==='spell'
            ?
            <div className="potter">
              <div className="potter_info">
                <Logo />
                <Searchbox searchChange={searchChange} route={route}/>
                <SpellList spell={filterSpell} />
              </div>
            </div>
            :<div>
              <Heading />
              <Register onRouteChange={onRouteChange} loadUser={loadUser}/>
            </div>
            )
          )
        )
        }
      </div>
    );
  }
}
export default Home;
